<script>

import api from '@/utils/api'

export default {
  name: 'HeaderView',
  data () {
    return {
      api
    }
  },
  computed: {
    hasMenu () {
      return !!this.api.token
    },
    indexPage () {
      return this.$i18n.locale === 'en' ? 'https://platformcraft.com' : 'https://platformcraft.ru'
    }
  },
  methods: {
    switchLocaleRu () {
      this.$i18n.locale = 'ru'
      this.$cookie.set('lang', 'ru-RU')
    },
    switchLocaleEn () {
      this.$i18n.locale = 'en'
      this.$cookie.set('lang', 'en-US')
    }
  }
}

</script>

<template lang="pug">

.header
  .menu
    .menu-item.lang(@click="switchLocaleEn")
      .title EN
    .menu-item.lang(@click="switchLocaleRu")
      .title RU

</template>

<style scoped lang="sass">

.header
  background: #00B4DB
  background-image: linear-gradient(90deg,#010101,#2a2a2a)

.header, .menu
  height: 86px

.logo
  position: absolute
  left: 18px
  top: 16px
  width: 50px
  height: 50px
  background: url(assets/logo.png) no-repeat
  background-size: 50px 50px
  +retina
    background-image: url(assets/logo@2x.png)

.menu-item
  position: relative
  float: right
  height: 100%
  cursor: pointer
  text-transform: uppercase

.logout
  width: 52px
  &::after
    position: absolute
    width: 17px
    height: 17px
    left: 50%
    top: 50%
    transform: translate(-50%, -50%)
    background: url(assets/logout@2x.png) no-repeat
    background-size: 17px 17px
    transition: 150ms transform linear
    content: ''
  &:hover
    &::after
      transform: translate(-25%, -50%)

.title
  line-height: 96px
  text-align: center
  color: #fff

.lang, .help
  width: 120px
  transition: 150ms background-color linear
  &:hover
    background: #747474

.help
  &:hover
    .dropdown
      display: block
  .title
    &::after
      display: inline-block
      width: 10px
      height: 5px
      background: url(assets/arrow.svg) no-repeat
      content: ''
      transform: translate(5px, -2px)

.dropdown
  display: none
  position: absolute
  top: 100%
  left: 50%
  transform: translateX(-50%)
  font-size: 12px
  font-weight: $light
  background: $white
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16)
  cursor: default

.dropdown-item
  display: block
  padding: 10px 20px
  color: #505050
  &.line
    box-shadow: 0 1px rgba(148, 151, 153, 0.2)

a.dropdown-item:hover
  color: $white
  background: #FAB60A
  cursor: pointer

</style>
